import React, { ChangeEvent, useCallback, useEffect, useMemo, useState } from 'react';
import { FieldProps } from 'formik';
import debounce from 'lodash.debounce';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib';
import { MoneyInput as KitMoneyInput } from '@shared/ui/molecules';
import { InputHelperText, InputErrorMessage } from '@shared/ui/atoms';
interface MoneyProps extends FieldProps<string> {
  hint: string;
  onChange?: (value: string) => void;
  decimalLimit: number;
  onBlur?: (event: ChangeEvent) => void;
  onClear?: () => void;
}
export const MoneyInputField: FC<MoneyProps> = ({
  field,
  form: {
    touched,
    errors,
    setFieldTouched,
    setFieldValue
  },
  onChange,
  onBlur,
  hint,
  onClear,
  ...rest
}) => {
  const touchedItem = touched[field.name];
  const errorItem = errors[field.name];
  const [hasError, setHasError] = useState<boolean>(Boolean(touchedItem) && Boolean(errorItem));
  const setHasErrorDebounced = useMemo(() => debounce((hasError: boolean) => setHasError(hasError), 100, {
    leading: false,
    trailing: true
  }), [setHasError]);
  const handleChange = useCallback((value: string) => {
    if (onChange) {
      onChange(value);
    } else {
      setFieldValue(field.name, value);
      setFieldTouched(field.name, true, false);
    }
  }, [field.name, onChange, setFieldTouched, setFieldValue]);
  const handleClear = useCallback(() => {
    if (onClear) {
      onClear();
    } else {
      setFieldValue(field.name, '');
    }
  }, [field.name, setFieldValue, onClear]);
  useEffect(() => {
    setHasErrorDebounced(touchedItem && Boolean(errorItem));
  }, [touchedItem, errorItem, setHasErrorDebounced]);
  const handleBlur = useCallback((event: ChangeEvent) => {
    // todo вернуть если потребуется
    /* if (isNumber(rest.decimalLimit)) {
      const amountValue = field.value === '' ? '' : toNumber(field.value).toFixed(rest.decimalLimit)
       setFieldValue(field.name, amountValue, false)
      setFieldTouched(field.name, true, false)
    } */

    if (onBlur) {
      onBlur(event);
    }
    field.onBlur(event);
  }, [field, onBlur]);
  return <>
      <CustomMoneyInput {...field} {...rest} size="md" autoComplete="off" data-testid={field.name} hasError={hasError} onClear={handleClear} onChange={handleChange} onBlur={handleBlur} endIcon="icon-24/Lock" />
      {hint && !hasError && <InputHelperText>{hint}</InputHelperText>}
      {hasError && <InputErrorMessage name={field.name} />}
    </>;
};
const _exp = /*#__PURE__*/() => KitMoneyInput as FC;
const _exp2 = /*#__PURE__*/() => ({
  hasError,
  theme
}) => hasError ? theme.colors.state.active : theme.colors.text.tertiary;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp6 = /*#__PURE__*/() => ({
  hasError,
  theme
}) => hasError ? theme.colors.state.active : theme.colors.state.alternativeSecondaryHover;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp8 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.bg.tertiary;
const _exp9 = /*#__PURE__*/() => ({
  readOnly,
  theme
}) => readOnly ? theme.colors.text.tertiary : theme.colors.text.primary;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.state.inputHover;
const CustomMoneyInput = withTheme(/*#__PURE__*/styled(_exp())({
  name: "CustomMoneyInput",
  class: "cwgn00m",
  propsAsIs: true,
  vars: {
    "cwgn00m-0": [_exp2()],
    "cwgn00m-1": [_exp7()],
    "cwgn00m-2": [_exp4(), "px"],
    "cwgn00m-3": [_exp5()],
    "cwgn00m-4": [_exp6()],
    "cwgn00m-5": [_exp8()],
    "cwgn00m-6": [_exp9()],
    "cwgn00m-7": [_exp0()]
  }
}));

require("./MoneyInputField.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./MoneyInputField.tsx");